import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Info = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.86545 5.91568C8.86545 6.39362 8.478 6.78107 8.00006 6.78107C7.52212 6.78107 7.13467 6.39362 7.13467 5.91568C7.13467 5.43774 7.52212 5.05029 8.00006 5.05029C8.478 5.05029 8.86545 5.43774 8.86545 5.91568ZM7.86545 5.91568C7.86545 5.84134 7.92572 5.78107 8.00006 5.78107C8.07441 5.78107 8.13467 5.84134 8.13467 5.91568C8.13467 5.99002 8.07441 6.05029 8.00006 6.05029C7.92572 6.05029 7.86545 5.99002 7.86545 5.91568Z"
        fill="currentColor"
      />
      <path
        d="M6.90323 10.5313C7.00012 10.5309 7.0904 10.5025 7.16638 10.4538C7.2984 10.3691 7.38724 10.223 7.39251 10.0557L7.39275 10.04V8.07944C7.39275 7.90235 7.29905 7.74714 7.15852 7.6607C7.14802 7.65424 7.13726 7.64816 7.12626 7.64249C7.05938 7.60802 6.98358 7.58845 6.90322 7.58817L6.90148 7.58817C6.84721 7.58817 6.80322 7.54418 6.80322 7.48991V7.2716C6.80322 7.21696 6.84705 7.17255 6.90148 7.17162L6.90322 7.1716H8.42626C8.53671 7.1716 8.62626 7.26114 8.62626 7.3716V10.0557C8.62626 10.2254 8.71506 10.3742 8.84872 10.4584C8.92072 10.5038 9.00573 10.5303 9.09688 10.5312L9.10178 10.5313C9.1543 10.5313 9.19688 10.5738 9.19688 10.6264V10.8497C9.19688 10.9033 9.15473 10.9471 9.10178 10.9496L9.09688 10.9497H6.90323L6.90148 10.9497C6.84706 10.9488 6.80323 10.9044 6.80323 10.8497L6.80322 10.6295C6.80322 10.5753 6.84721 10.5313 6.90148 10.5313L6.90323 10.5313Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM12.75 8C12.75 10.6234 10.6234 12.75 8 12.75C5.37665 12.75 3.25 10.6234 3.25 8C3.25 5.37665 5.37665 3.25 8 3.25C10.6234 3.25 12.75 5.37665 12.75 8Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Info;
